import React, { useState, useEffect } from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Card, CardBody, Container } from 'reactstrap';

//redux
// import GuideForm from '../Forms/GuideForm';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GuideForm from './Forms/GuideForm';
import { FormDictionaryProvider } from './Forms/FormDictionaryContext';
import { useDispatch, useSelector } from 'react-redux';
import { loginWarehouseDTE } from '../../../slices/warehouseGuide/thunk';

const DispatchGuideRegister = () => {
	const history = useNavigate();
	const dispatch = useDispatch();
	const [searchParams] = useSearchParams();
	const [title, setTitle] = useState('');
	
	// Obtener categoría de query params (ej: ?category=residuos)
	const categoryParam = searchParams.get('category');
	
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '#', label: categoryParam === 'residuos' ? 'Residuos' : 'Bodega' },
		{
			to:
				categoryParam === 'residuos'
					? '/warehouse/guides'
					: '/warehouse/dashboard',
			label: 'Guía de Despacho',
		},
	];

	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	const { isDTEAuthLoading, isDTEAuthSuccess } = useSelector(
		state => state.WarehouseGuide
	);

	useEffect(() => {
		dispatch(loginWarehouseDTE());
	}, [dispatch]);

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title={title} links={breadcrumbLinks} />
					<Card>
						<CardBody>
							<FormDictionaryProvider>
								<GuideForm
									activeTab={activeTab}
									handleChangeTitleForm={newTitle => {
										setTitle(newTitle);
									}}
									handleToggleModal={() => history('/warehouse/guides')}
									requireGuideDetailRegisterList={true}
									initialCategory={categoryParam || ''}
								/>
							</FormDictionaryProvider>
						</CardBody>
					</Card>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default DispatchGuideRegister;
